import React from 'react';
import PageInfoStore from './flux/PageInfoStore';

export default function MainNavColorBar() {
  
  return (
    <span>
      <a
        href="/search"
        className="search"
        onMouseEnter={((e) => {
          PageInfoStore.setSelectedSubMenu(false);
        })}
        onClick={((e) => {
          e.preventDefault();
          // PageInfoStore.toggleSearchBar();
          PageInfoStore.setSelectedSubMenu('search');
        })}
      >
        <i className="fa-solid fa-magnifying-glass"></i> Search
      </a>
      {/* <a href="/account/login" className="login">
        <i className="fa-solid fa-user"></i> Sign Up / Login
      </a> */}
    </span>
  );
}